import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ["submit", "form"]
  static values = { 
    loading: String,
    success: String,
    error: String
  }

  connect() {
    console.log("Form controller connected")
    
    // Listen for turbo events
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart.bind(this))
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
    this.element.addEventListener("turbo:before-stream-render", this.handleBeforeStreamRender.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart.bind(this))
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
    this.element.removeEventListener("turbo:before-stream-render", this.handleBeforeStreamRender.bind(this))
  }

  handleSubmitStart(event) {
    this.setLoadingState(true)
  }

  handleSubmitEnd(event) {
    this.setLoadingState(false)
    
    // Check if form submission was successful
    if (event.detail.success) {
      this.showSuccess()
    }
  }

  handleBeforeStreamRender(event) {
    // This fires before Turbo Stream updates are applied
    console.log("Turbo Stream about to render")
  }

  setLoadingState(loading) {
    if (this.hasSubmitTarget) {
      const submitButton = this.submitTarget
      
      if (loading) {
        submitButton.disabled = true
        submitButton.dataset.originalText = submitButton.innerHTML
        submitButton.innerHTML = this.loadingValue || '<i class="bi bi-hourglass-split me-2"></i>处理中...'
        submitButton.classList.add('btn-loading')
      } else {
        submitButton.disabled = false
        if (submitButton.dataset.originalText) {
          submitButton.innerHTML = submitButton.dataset.originalText
          delete submitButton.dataset.originalText
        }
        submitButton.classList.remove('btn-loading')
      }
    }
  }

  showSuccess() {
    // Add success animation
    if (this.hasSubmitTarget) {
      const submitButton = this.submitTarget
      const originalClass = submitButton.className
      
      submitButton.classList.add('btn-success')
      submitButton.innerHTML = '<i class="bi bi-check-circle me-2"></i>成功！'
      
      setTimeout(() => {
        submitButton.className = originalClass
        if (submitButton.dataset.originalText) {
          submitButton.innerHTML = submitButton.dataset.originalText
        }
      }, 2000)
    }
  }

  showError(message) {
    // Show error notification
    const notification = document.createElement('div')
    notification.className = 'alert alert-danger alert-dismissible fade show position-fixed'
    notification.style.cssText = 'top: 20px; right: 20px; z-index: 9999; max-width: 400px;'
    notification.innerHTML = `
      <i class="bi bi-exclamation-triangle me-2"></i>
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `
    
    document.body.appendChild(notification)
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove()
      }
    }, 5000)
  }

  // Reset form method
  reset() {
    if (this.hasFormTarget) {
      this.formTarget.reset()
      
      // Clear any validation errors
      this.formTarget.querySelectorAll('.is-invalid').forEach(element => {
        element.classList.remove('is-invalid')
      })
      
      this.formTarget.querySelectorAll('.invalid-feedback').forEach(element => {
        element.remove()
      })
    }
  }

  // Auto-submit functionality
  autoSubmit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
